import { Form, Modal } from "react-bootstrap";
import { TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createNotification } from "react-redux-notify";

import { getUserId } from "../../../helpers/storage/user";
import { isAlphanumeric } from "../../../helpers/validator/string";
import { getErrorNotificationMessage } from "../../../components/helper/NotificationMessage";
import { SocketContext as StreamingSocketContext } from "../../../helpers/contexts/streaming";

const EditStreamDescription = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const { updateChannel } = useContext(StreamingSocketContext);
  const { data } = useSelector((state) => state.liveStreaming.streamerChannel);

  const [settings, setSettings] = useState(data?.settings || {});
  const [description, setDescription] = useState(data?.description || "");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isAlphanumeric(description)) {
      return dispatch(
        createNotification(
          getErrorNotificationMessage(
            "Description must contain only alphanumeral characters, '-', '_', and ' '."
          )
        )
      );
    }
    updateChannel(data.id, getUserId(), { description, settings });
    toggle();
  };

  const onDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const onShowCollectedTipChange = (e) => {
    setSettings({
      ...settings,
      showCollectedTip: e.target.checked,
    });
  };

  return (
    <Modal
      className={`golivemodal dj ${
        localStorage.getItem("isDark") === "true" ? "dark" : "light"
      }`}
      size="md"
      centered
      show={isOpen}
      onHide={toggle}
    >
      <Form onSubmit={handleSubmit} translate="no">
        <Modal.Header>
          <div className="text-center w-100 bold">Edit Stream Description</div>
        </Modal.Header>
        <Modal.Body className="p-22">
          <>
            <p>
              Here you can add some information about stream (topic, tips,
              goals)
            </p>
            <div className="mb-3 bb-red">
              <TextField
                label="type here"
                id="standard-basic"
                value={description}
                onChange={onDescriptionChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="button one">
                <input
                  type="checkbox"
                  name="group1"
                  className="mr-1"
                  onChange={onShowCollectedTipChange}
                  checked={settings.showCollectedTip || false}
                />
                Display collected tips to viewers
              </label>
            </div>
          </>
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-border mr-1 w-100"
              onClick={() => toggle()}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-danger w-100">
              Save
            </button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

export default EditStreamDescription;
